import { cursorPaginationFieldPolicy } from '../../../../../utils/policies/cursorPaginationFieldPolicy';
import type { TypePolicies } from '../../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      accountUsers: cursorPaginationFieldPolicy([
        '$accountId',
        'orderBy',
        'filter',
        ['query', 'accountUserIsPending'],
      ]),
    },
  },
  Account: {
    fields: {
      accountUsers: cursorPaginationFieldPolicy([
        'orderBy',
        'filter',
        ['query', 'accountUserIsPending', 'accountUserIsDeleted'],
        '@connection',
        ['key'],
      ]),
    },
  },
};
